import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export var ObjectFieldTemplate = function (props) {
    var properties = props.properties;
    return _jsx(_Fragment, { children: properties.map(function (element) { return element.content; }) });
};
